//------------------------------------------------------------------------------
// サイドバー アクション
//------------------------------------------------------------------------------
import types from './types';

/**
 * サイドバー開閉状態設定
 */
export const setSidebarOpen = (open) => {
  return {
    type: types.OPEN,
    open,
  };
};
